import script from "./ReportDigestSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDigestSettings.vue?vue&type=script&setup=true&lang=js"

import "./ReportDigestSettings.vue?vue&type=style&index=0&id=2345615a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2345615a"]])

export default __exports__